export default {
  common: {
    loading: '加载中...',
    loadFailed: '加载失败，请确认后端已启动',
    loadFailedShort: '加载失败',
    requestFailed: '请求失败',
    submitFailed: '提交失败',
    articleNotFound: '文章不存在',
    siteSuffix: '官网',
    industrialCorp: 'Industrial Corp.',
    home: '首页',
    arrow: '→',
    back: '←',
    views: '次浏览',
    by: '作者',
  },
  nav: {
    contactUs: '联系我们',
    getQuote: '立即询价',
    menu: '菜单',
    routes: {
      home: '首页',
      news: '新闻动态',
      about: '关于我们',
      contact: '联系我们',
    },
  },
  footer: {
    aboutCompany: '关于公司',
    usefulLinks: '实用链接',
    services: '制造服务',
    aboutUs: '关于我们',
    news: '新闻动态',
    contact: '联系我们',
    office: '办公地址',
    certifications: '认证',
    serviceCnc: 'CNC 加工',
    serviceInjection: '注塑成型',
    serviceSheetMetal: '钣金加工',
    servicePrinting: '3D 打印',
  },
  home: {
    heroTag: '从原型到量产',
    heroTitle: '优质零部件，制造更简单、更快速',
    heroDesc: '您的设计，我们的精度。从早期打样到批量生产，我们以速度、可靠性与稳定品质，将您的方案落地。',
    promoText: '无需复杂流程，描述需求即可开始打样评估。',
    promoLink: '立即体验',
    quoteTitle: '我们能帮您做什么？',
    quoteName: '您的姓名',
    quoteEmail: '邮箱',
    quotePhone: '电话',
    quoteCompany: '公司',
    quoteMessage: '项目需求',
    quoteSubmit: '提交询盘',
    quoteSubmitting: '提交中...',
    quoteSuccess: '提交成功，我们会尽快联系您',
    getQuote: '获取即时报价',
    servicesLabel: 'Manufacturing Services',
    servicesTitle: '从打样到量产的制造服务',
    servicesDesc: '自有工厂与优质供应链网络，提供 CNC 加工、注塑成型、钣金、3D 打印等能力，满足快速打样与批量生产需求。',
    toolsLabel: 'Smart Manufacturing',
    toolsTitle: '更智能的制造工具',
    partnerLabel: 'Global Partner',
    partnerTitle: '您在中国的可信赖制造伙伴，全球发货',
    partnerDesc: '立足中国，整合自有产线与优质供应商，为北美、欧洲客户提供 3–10 天跨境交付。英语项目工程师 12 小时内响应。',
    platformLabel: 'Digital Platform',
    platformTitle: '数字化平台，更智能地管理制造全流程',
    platformDesc: '从即时报价、DFM 分析到订单跟踪与项目管理，一站式掌控定制零部件生产。',
    processLabel: 'How It Works',
    processTitle: '如何与我们合作',
    processCta: '开始即时报价',
    qualityLabel: 'Quality Assurance',
    qualityTitle: '品质与可靠性并重',
    feedbackLabel: 'Customer Feedback',
    feedbackTitle: '客户评价',
    newsLabel: 'Manufacturing Resources',
    newsTitle: '制造资源与行业洞察',
    viewAll: '查看全部',
    ctaTitle: '预约与我们的制造专家沟通',
    ctaDesc: '上传图纸或描述需求，获取报价、DFM 反馈与交期评估。',
    ctaButton: '立即询价',
    contactUs: '联系我们',
    heroFallback1: 'PRECISION',
    heroFallback2: 'MANUFACTURER IN CHINA',
    factoryAlt: '工厂',
  },
  about: {
    title: '关于我们',
    label: 'About Us',
  },
  contact: {
    title: 'Contact Us',
    subtitle: '欢迎留下您的需求，我们将尽快与您联系',
    breadcrumb: '联系我们',
    getInTouch: 'Get In Touch',
    address: '地址',
    phone: '电话',
    email: '邮箱',
    successTitle: '提交成功',
    successDesc: '感谢您的留言，我们会尽快回复。',
    name: '姓名',
    company: '公司',
    message: '留言',
    required: '*',
    submitting: '提交中...',
    submit: '发送咨询',
  },
  news: {
    title: 'News & Blog',
    subtitle: '行业洞察与案例分享',
    breadcrumb: '新闻动态',
    empty: '暂无文章',
    prev: '上一页',
    next: '下一页',
    detailBreadcrumb: '新闻动态',
    backToNews: 'Back to News',
  },
  article: {
    categoryNews: '新闻',
  },
  faq: {
    label: 'FAQ',
    title: '常见问题',
    subtitle: '关于制造能力与服务的常见问题解答',
  },
  meta: {
    home: '首页',
    news: '新闻动态',
    newsDetail: '文章详情',
    about: '关于我们',
    contact: '联系我们',
  },
  sections: {
    productRange: {
      title: '产品范围与应用',
      description:
        '我们根据您的行业与产品设计，确定最优制造工艺。宽公差产品推荐锻造；高精度零件可采用锻造 + CNC 组合，提升强度并降低综合成本。',
      materials1: [
        '铝合金 (4032-T6, 6061-T6, 7075-T6)',
        '碳钢 (Q345, 42CrMo, AISI 4140)',
      ],
      materials2: [
        '黄铜 & 青铜 (H62, C3604, C5191)',
        '不锈钢 (303, 304, 316, 420, 431)',
      ],
    },
    aboutHighlights: [
      'ISO 9001 & IATF 16949 认证制造商',
      '13 条锻造产线，65 台 CNC 铣床，20 台 CNC 车床',
      '1,600 吨锻造压力机，可加工最大 500mm 零件',
      '配备 CMM、X 射线、高度规等全套检测实验室',
    ],
    stats: [
      { value: '26+', label: '年行业经验' },
      { value: '400+', label: '员工' },
      { value: '56,000 m²', label: '工厂面积' },
      { value: '40+', label: '出口国家' },
    ],
    teamMembers: [
      { name: '张总', role: '创始人 / CEO' },
      { name: '李经理', role: '副总经理' },
      { name: '王工', role: '工程总监' },
      { name: '陈经理', role: '采购经理' },
      { name: '刘经理', role: '品质经理' },
      { name: '赵工', role: '模具设计经理' },
      { name: '黄厂长', role: '工厂厂长' },
    ],
    testimonials: [
      {
        text: '交付准时、品质稳定，PPAP 文档完整专业，是我们长期合作的首选供应商。',
        author: '— 某国际汽车 Tier 1 采购总监',
      },
      {
        text: '从模具设计到量产，项目团队响应迅速，DFM 报告专业详实，大幅缩短了开发周期。',
        author: '— 某新能源设备商 质量经理',
      },
      {
        text: '26 年来一直是全球 OEM 在医疗、汽车及新能源领域的可靠合作伙伴。',
        author: '— 某通讯设备商 工程总监',
      },
    ],
    faqs: [
      {
        q: '最小起订量 MOQ 是多少？',
        a: '新开模具 MOQ 通常 1000 件；CNC 直接加工最低 1 件，适合打样与小批量验证。',
      },
      {
        q: '是否具备出口经验？',
        a: '拥有 18+ 年国际贸易经验，产品出口 40+ 国家，熟悉 IATF 16949、ISO 9001、RoHS、REACH 等国际标准。',
      },
      {
        q: '如何保证产品质量？',
        a: '遵循 ISO 9001 与 IATF 16949 体系，配备 CMM、光谱仪、拉力试验机等全套检测设备，全流程 IPQC/OQC。',
      },
      {
        q: '开发周期一般多长？',
        a: '模具开发 3~5 周，样品 1~2 周；具体视零件复杂度与工艺路线而定，12 小时内响应询盘。',
      },
    ],
    certifications: [
      { label: 'ISO 9001' },
      { label: 'IATF 16949' },
    ],
    heroStats: [
      { value: '26+', label: '年行业经验' },
      { value: '100,000+', label: '零部件交付' },
      { value: '700+', label: '合作制造中心' },
      { value: '98%', label: '准时交付率' },
    ],
    services: [
      { title: 'CNC 加工', desc: '铣削、车削与精密加工，±0.025mm 公差，薄壁 0.5mm，最快 1 天交期。', slug: 'cnc' },
      { title: '注塑成型', desc: '塑料注塑、包胶与嵌件成型，无 MOQ 限制，T1 样品 2 周，1 至 100 万件量产。', slug: 'injection' },
      { title: '钣金加工', desc: '激光切割、折弯、焊接与冲压，3 天交期，薄壁 0.2mm 起。', slug: 'sheet-metal' },
      { title: '3D 打印', desc: 'SLA、SLS、MJF 与 SLM，功能样机与小批量，±0.2mm 精度，1 天交期。', slug: '3d-printing' },
      { title: '铝挤压', desc: '高品质低成本金属挤压，多种后加工选项，2 周快速交付。', slug: 'extrusion' },
      { title: '压铸', desc: '铝/锌/镁/铜高压压铸，壁厚 0.8mm 起，1000+ 件批量。', slug: 'die-casting' },
      { title: '真空复模', desc: '软模小批量塑料件，±0.05mm 精度，15 天 20 件，适合快速迭代。', slug: 'vacuum-casting' },
      { title: '线切割 EDM', desc: '精密电火花加工，内角与薄壁，无毛刺微加工，复杂几何免工装。', slug: 'wire-edm' },
    ],
    tools: [
      { title: '即时报价', desc: '上传 3D 模型，秒级获取报价、DFM 反馈与生产管控。', cta: '上传图纸询价', link: '/contact' },
      { title: '工程评审', desc: '无图纸？描述您的想法，工程团队提供可制造性方案与工艺路线。', cta: '联系工程师', link: '/contact' },
    ],
    partnerStats: [
      { value: '20,000+', label: '全球客户' },
      { value: '120+', label: '国家与地区' },
      { value: '700+', label: '设备台套' },
      { value: '56,000 m²', label: '工厂总面积' },
    ],
    factories: [
      { name: 'CNC 加工中心', established: '2017', machines: '400 台', location: '佛山' },
      { name: '钣金工厂', established: '2020', machines: '51 台', location: '深圳' },
      { name: '注塑工厂', established: '2021', machines: '20 台', location: '深圳' },
      { name: '3D 打印中心', established: '2019', machines: '285 台', location: '东莞' },
    ],
    platformFeatures: [
      {
        title: '即时报价',
        desc: '跳过等待，秒级获取准确价格与 DFM 反馈，降低风险、保障交期。',
        points: ['无最低起订量', '100+ 材料与 30+ 表面处理', '灵活交期与物流选项'],
      },
      {
        title: '团队协作',
        desc: '一键分享报价与规格，集中审批与付款，提升团队效率。',
        points: ['一键分享报价与订单', '集中审批缩短周期', '专属客户经理支持'],
      },
      {
        title: '在线沟通',
        desc: '实时在线支持，快速解答报价与订单问题，文件与标注即时共享。',
        points: ['报价订单快速响应', '文件照片即时共享', '设计反馈与标注'],
      },
      {
        title: '订单管理',
        desc: '单一平台管理报价、订单与生产进度，透明可控的一站式体验。',
        points: ['实时生产状态跟踪', '高清质检照片', 'DFM 至发票文档管理'],
      },
    ],
    processSteps: [
      { title: '上传 CAD 文件', desc: '选择制造工艺，上传设计文件。', items: ['选择工艺路线', '上传 2D/3D 图纸', '补充材料与数量'] },
      { title: '获取报价', desc: '配置材料、表面处理与数量，收到报价与 DFM 反馈后下单。', items: ['即时/人工报价', 'DFM 可制造性分析', '确认交期与物流'] },
      { title: '零件交付', desc: '生产完成并通过质检后，全球发货至您的指定地址。', items: ['全流程 IPQC/OQC', '检验报告随货', '3–10 天跨境物流'] },
    ],
    qualityItems: [
      { title: '先进检测设备', desc: 'CMM、2D 测量仪、XRF、千分尺等 20+ 类工具，覆盖尺寸、材料与表面质量。' },
      { title: '完整检验文档', desc: '首件检验 FAI、RoHS 合规、尺寸测量与功能测试报告，支持您的质量体系。' },
      { title: '认证制造伙伴', desc: 'ISO 9001、IATF 16949 等认证，服务汽车、医疗、消费电子等高标准行业。' },
    ],
  },
};
